<template>
    <div class="list-container" :id="listID">
        <button type="button" class="rounded-button" @click="NewItem">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
            </svg>
        </button>
        <div class="list-container-item" v-for="(item, index) in list" :key="index">
            <input class="list-container-input" type="text" :value="list[index]" @input="(e)=>{list[index] = e.target.value}">
            <button type="button" class="ml-auto" @click="RemoveItem(index)">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        listID: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            list: []
        }
    },
    methods: {
        GetData() {
            return this.list
        },
        NewItem() {
            this.list.push("")
        },
        RemoveItem(index) {
            this.list.splice(index, 1)
        }
    },
    watch: {
        data(newVal, oldVal) {
            this.list = JSON.parse(JSON.stringify(newVal))
        }
    }
}
</script>